import React from "react";
import PropTypes from "prop-types";
import Heading from "./../../atoms/Heading";
import styled from "styled-components";
import DeliveryItem from "./../../molecules/DeliveryItem";
import { redirectFromCheckout } from "../../../utils/functions";

const Wrap = styled.div``;

const MainHeading = styled(Heading)`
    padding-top: 0;
    padding-bottom: 8px;
    font-size: 36px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: -1.95px;

    @media (min-width: 990px) {
        margin-bottom: 24px;
        border-bottom: none;
        font-size: 48px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: -2.6px;
    }
`;

const DeliveryWrap = styled.div``;

function UpcomingDeliveries(props) {

    let {
        charges,
        orders,
        handleEditDelivery,
        exclusions,
        customerId,
        isOldUser,
        isCustomerActive
    } = props;

    const handleChangeQuantity = (id, main_title) => {
        props.handleChangeQuantity(id, main_title);
    };

    // //Add redirection from accont/login to checkout page if login was from checkout!!!
    // const searchCustomParam = localStorage.getItem("SearchCustomParam");
    //     if (searchCustomParam && searchCustomParam.includes('checkout_url')) {
    //     const urlRedirection = decodeURIComponent(searchCustomParam).split('checkout_url=')[1];
    //     localStorage.removeItem("SearchCustomParam");
    //     window.location.href = urlRedirection
    // } else if (searchCustomParam) {
    //     localStorage.removeItem("SearchCustomParam");
    // }
    redirectFromCheckout();

    return (
        <Wrap>
            <MainHeading>Upcoming Deliveries</MainHeading>
            <p>Below, you'll find your future upcoming deliveries.</p>
            <DeliveryWrap>
                {orders.map((order) => {
                    return (
                        <DeliveryItem
                            {...order}
                            key={order.id}
                            exclusions={exclusions}
                            handleChangeQuantity={handleChangeQuantity}
                            handleEditDelivery={handleEditDelivery}
                            isOrder={true}
                            customerId={customerId}
                            isOldUser={isOldUser}
                        />
                    );
                })}
                {(isCustomerActive === true) && (
                    charges.map((charge) => {
                        let processedDate = null;
                        for (let order of orders) {
                            if (order.addressId === charge.addressId) {
                                processedDate = order.processedAt;
                                break;
                            }
                        }
                        return (
                            <DeliveryItem
                                {...charge}
                                key={charge.id}
                                exclusions={exclusions}
                                handleChangeQuantity={handleChangeQuantity}
                                handleEditDelivery={handleEditDelivery}
                                isOrder={false}
                                customerId={customerId}
                                isOldUser={isOldUser}
                                // processedAt={processedDate}
                            />
                        );
                    })
                )}
            </DeliveryWrap>
        </Wrap>
    );

}

UpcomingDeliveries.propTypes = {
    additionals: PropTypes.array,
    breakfasts: PropTypes.array,
    charges: PropTypes.array,
    diets: PropTypes.array,
    editSubscription: PropTypes.object,
    entrees: PropTypes.array,
    exclusions: PropTypes.array,
    meals: PropTypes.array,
    orders: PropTypes.array,
    step: PropTypes.number,
    upcomingDeliveryMeals: PropTypes.array,
    customerId: PropTypes.number,
    handleChangeQuantity: PropTypes.func,
    handleEditDelivery: PropTypes.func,
};

export default UpcomingDeliveries;
